import React, { useEffect, useState } from "react";
import { Tooltip, Modal, Button, Progress } from "antd";
import { useSelector, useDispatch } from "react-redux";
import domtoimage from "dom-to-image-more";
import TemplatePreview from "./TemplatePreview";
import {
  getPaneIndex,
  getCustomizedDate,
  deepCopy,
  getDefaultCompBrand,
  getByDefaultProfileFilters,
  processQuickFilterForADCampaign,
} from "../../../redux/constants";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import combinationChart from "../../../assets/WidgetLibrary/combinationChart.svg";
import barChart from "../../../assets/WidgetLibrary/barChart.svg";
import horizontalBarChart from "../../../assets/WidgetLibrary/sideBarChart.svg";
import areaChart from "../../../assets/WidgetLibrary/areaChart.svg";
import lineChart from "../../../assets/WidgetLibrary/lineChart.svg";
import pieChart from "../../../assets/WidgetLibrary/pieChart.svg";
import doughnutChart from "../../../assets/WidgetLibrary/dounutChart.svg";
import bubbleChart from "../../../assets/WidgetLibrary/bubbleChart.svg";
import wordCloudChart from "../../../assets/WidgetLibrary/wordCloudChart.svg";
import histogram from "../../../assets/WidgetLibrary/Histogram.svg";
import gridChart from "../../../assets/WidgetLibrary/tableChart.svg";
import mapChart from "../../../assets/WidgetLibrary/mapChart.svg";
import heatmapChart from "../../../assets/WidgetLibrary/heatmapChart.svg";
import sunburstChart from "../../../assets/WidgetLibrary/sunburstChart.svg";
import numberChart from "../../../assets/WidgetLibrary/numberChart.svg";
import pivotChart from "../../../assets/WidgetLibrary/pivot.svg";
import postCardChart from "../../../assets/WidgetLibrary/postcard.svg";
import prolificLibraryIcon from "../../../assets/WidgetLibrary/prolific_libraryIcon.svg";
import Alert from "../../../assets/ppt/Alert.svg";
import pptDownloadImagesGray from "../../../assets/ppt/DownloadImages_gray.svg";
import pptDownloadNativeGray from "../../../assets/ppt/DownloadNative_gray.svg";
import pptDownloadImages from "../../../assets/ppt/DownloadImages.svg";
import pptDownloadNative from "../../../assets/ppt/DownloadNative.svg";
import rotate_right from "../../../assets/rotate_right_.svg";
import { notification } from "antd";
import {
  setCallPpt,
  setdownload,
  setImageList,
  setPptDownload,
  setPPTGenerateStatus,
  setPptImageUrl,
  setPptLoaderOffset,
  setPPTModalOpen,
  setPptTemplateData,
} from "../../../redux/actions/PPT.js";
import {
  setPdfPreviewMode,
  setPPTDashboardData,
} from "../../../redux/actions/ApiCall/apiCall";
import moment from "moment";
import { memo } from "react";
import { setPaneBrands } from "../../../redux/actions/dashboard/Tab1";
import isEqual from "react-fast-compare";

const ModalPpt = () => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const mapRendered = useSelector((state) => state.PPT.mapRendered);

  const [chartTypeData, setChartTypeData] = useState(null);
  const [modalDataChange, setModalDataChange] = useState(true);
  const [isImgselect, setIsImgselect] = useState(
    authParams?.ppt_type ? authParams?.ppt_type : "native"
  );
  const [dataList, setdataList] = useState(null);
  const [notSupportedChart, setNotSupportedChart] = useState(false);
  const [seeMore, setSeeMore] = useState(false);
  const [seenoDataWidgets, setSeenoDataWidgets] = useState(false);

  const [themeList, setThemeList] = useState(false);
  const [selectedThemes, setSelectedThemes] = useState({
    id: authParams?.theme_id ? parseInt(authParams?.theme_id) : 0,
    value: false,
  });
  const download = useSelector((state) => state.PPT.downloadPPT);
  // const aiGenerated = useSelector((state) => state.PPT.aiGenerated);
  const [aiGenerated, setAiGenerated] = useState(false);
  const [createPPTFlg, setcreatePPTFlg] = useState(false);
  const [previewModal, setPreviewModal] = useState({
    preview: false,
    templateData: null,
  });

  const [indicatorToChachePdfData, setIndicatorToChachePdfData] =
    useState(false);

  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const PPTdashboardData = useSelector(
    (state) => state.ApiCall.PPTdashboardData
  );
  const isPPTModalOpen = useSelector((state) => state.PPT.isPPTModalOpen);
  //const pptGenerateStatus = useSelector((state) => state.PPT.pptGenerateStatus);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const image_list = useSelector((state) => state?.PPT?.image_list);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  //const opData = useSelector((state) => state.Highchart.Options);
  const ppt_template_data = useSelector(
    (state) => state?.PPT?.ppt_template_data
  );
  const call_ppt = useSelector((state) => state.PPT.call_ppt);
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  let index = getPaneIndex(panes, activeKey);
  const selectedDate = panes[index].duration;
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const ppt_offset = useSelector((state) => state.PPT.ppt_offset);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const templateDetails = useSelector((state) => state.Section.templateDetails);

  // const profileFilterList = useSelector(
  //   (state) => state?.apiCall?.profile_filter_list
  // );
  const profileFilterList =
    window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
    window.location.pathname?.split("/")?.[1] === "create-dashboard"
      ? templateDetails?.profile_filters_list
      : panes?.[index]?.profile_filters_list;

  const supportedChart = [
    "bar",
    "horizontal-bar",
    "area",
    "line",
    "kpi",
    "grid",
  ];
  const unSupportedChart = [
    "bubble",
    "combination",
    "donut",
    "pie",
    "wordcloud",
    "map",
    "heatmap",
    "sunburst",
    "post-card",
    "survey-card",
    "prolific",
    "pivot-grid",
    "news-card",
    "rich-text",
    "treemap",
  ];

  const chartsList =
    chartTypeData && chartTypeData?.map((el, i) => el?.graph_type);
  const newChartList = new Set(chartsList);
  const finalUnSupportedChart =
    newChartList &&
    [...newChartList].filter((el, i) => unSupportedChart?.includes(el));
  const noDataWidgets =
    dataList &&
    [...dataList].filter((el, i) => {
      return typeof el?.graphData === "string";
    });
  const chartTypewithicon = {
    combination: combinationChart,
    bar: barChart,
    horizontalbar: horizontalBarChart,
    area: areaChart,
    line: lineChart,
    pie: pieChart,
    donut: doughnutChart,
    grid: gridChart,
    bubble: bubbleChart,
    wordcloud: wordCloudChart,
    kpi: numberChart,
    map: mapChart,
    heatmap: heatmapChart,
    sunburst: sunburstChart,
    histogram: histogram,
    postcard: postCardChart,
    pivotgrid: pivotChart,
    prolificuser: prolificLibraryIcon,
  };

  useEffect(() => {
    !isPPTModalOpen && dispatch(setdownload(false));
  }, [isPPTModalOpen]);

  const handleCancel = (value) => {
    dispatch(setImageList(null));
    if (!value) {
      dispatch(setPPTModalOpen(false));
      global.image_list = null;
    }
  };
  const shedString = (string, separator) => {
    //we split the string and make it free of separator
    const separatedArray = string?.split(separator);
    //we join the separatedArray with empty string
    const separatedString = separatedArray?.join("");
    return separatedString;
  };

  const storeScreenShots = (chartTypeData) => {
    dispatch(setPPTDashboardData(false));
    let timer = setTimeout(() => {
      chartTypeData &&
        chartTypeData.forEach((el, i) => {
          screenshot(
            el?.widget_id,
            i,
            isImgselect,
            chartTypeData,
            chartTypeData?.length
          );
        });
    }, [9000]);
    return () => {
      clearTimeout(timer);
    };
  };
  useEffect(() => {
    if (
      createPPTFlg &&
      chartTypeData?.length > 0 &&
      (image_list?.length === chartTypeData?.length ||
        global.image_list?.length === chartTypeData?.length)
    ) {
      createPayload();
    }
    let timer;
    if (download) {
      timer = setTimeout(() => {
        let value = ppt_offset + 2;
        if (value >= 90) {
          value = 90;
        }
        dispatch(setPptLoaderOffset(value));
      }, 2000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [download, image_list, chartTypeData, ppt_offset, createPPTFlg]);
  useEffect(() => {
    if (PPTdashboardData) {
      let isMapWidget = false;
      let data = panes[index]?.sections
        ? deepCopy(panes[index]?.sections)
        : deepCopy(panes[index]?.section);
      let chartData = [];
      data &&
        data?.forEach((el) =>
          el?.widgets?.forEach((e) => {
            if (
              (e?.graph_type === "map" || e?.chart?.chart_type === "map") &&
              e?.graphData !== "No data found"
            ) {
              isMapWidget = { map: true };
            }
            chartData = [
              ...chartData,
              {
                graph_type: e?.graph_type
                  ? e?.graph_type
                  : e?.chart?.chart_type,
                widget_name: e?.widget_name,
                widget_id: e?.widget_id,
                graphData: e?.graphData,
                isDurationComparisonExists:
                  e?.chart?.chart_type === "grid" &&
                  (e?.chart?.chart_settings
                    ?.show_previous_duration_comparison ||
                    e?.chart?.chart_settings?.show_previous_duration_data),
                downloadAsImage:
                  e?.chart?.chart_type === "grid" &&
                  e?.graphData?.data?.["grid"]?.[0]?.row_span_on,
              },
            ];
          })
        );
      chartData && setdataList(chartData ? chartData : null);
      chartData && setChartTypeData(chartData ? chartData : null);
      if (isMapWidget?.map) {
        storeScreenShots(chartData);
      } else if (!isMapWidget && !mapRendered) {
        storeScreenShots(chartData);
      }
    }
  }, [PPTdashboardData, mapRendered]);

  function isValidUrl(string) {
    try {
      new URL(string);
      return true;
    } catch (err) {
      return false;
    }
  }

  const createPayload = () => {
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let obj = deepCopy(panes[index]);
    const sections = obj?.sections
      ? obj?.sections?.map((el) => {
          return { widgets: el?.widgets };
        })
      : obj?.section?.map((el) => {
          return { widgets: el?.widgets };
        });

    let updated_obj = (({
      template_name,
      template_description,
      hidden_filter,
      quick_filter,
      profileInfo,
      duration,
      brands,
      sections,
      section,
    }) => ({
      template_name,
      template_description,
      hidden_filter,
      quick_filter,
      profileInfo,
      duration,
      brands,
      sections,
      section,
    }))(obj);
    let list = global.image_list ? global.image_list : image_list;

    updated_obj?.sections
      ? updated_obj?.sections?.forEach((section) => {
          section?.widgets?.forEach((widget) => {
            let index = list?.findIndex(
              (el) => el?.widget_id === widget?.widget_id
            );

            let data = list[index]?.url;
            if (authParams?.ai === "true" && isValidUrl(data)) {
              widget.graph_type = list?.[index]?.graph_type;
              widget.graphData = {
                data:
                  typeof widget?.graphData === "string"
                    ? "No data found"
                    : widget.graphData?.data,
                widget_url: data ? data : "No data found",
              };
            } else {
              widget.graph_type = list?.[index]?.graph_type;
              widget.graphData = data ? data : "No data found";
            }
          });
        })
      : updated_obj?.section?.forEach((section) => {
          section?.widgets?.forEach((widget) => {
            let index = list?.findIndex(
              (el) => el?.widget_id === widget?.widget_id
            );
            let data = list[index]?.url;
            if (authParams?.ai === "true" && isValidUrl(data)) {
              widget.graph_type = list?.[index]?.graph_type;
              widget.graphData = {
                data:
                  typeof widget?.graphData === "string"
                    ? "No data found"
                    : widget.graphData?.data,
                widget_url: data ? data : "No data found",
              };
            } else {
              widget.graph_type = list?.[index]?.graph_type;
              widget.graphData = data ? data : "No data found";
            }
          });
        });

    // let quick_filter =
    //   updated_obj?.quick_filter === "AccountID"
    //     ? "SettingID"
    //     : updated_obj?.quick_filter;

    let finalFilters = updated_obj?.filters;
    // quick_filter || updated_obj?.hidden_filter
    //   ? authParams?.filters?.filter(
    //       (el) =>
    //         el?.attribute !== quick_filter &&
    //         el?.attribute !== updated_obj?.hidden_filter?.attribute
    //     )
    //   :

    updated_obj.duration =
      authParams?.start_date && authParams?.end_date
        ? { from: authParams?.start_date, to: authParams?.end_date }
        : obj?.duration
        ? obj?.duration
        : defaultDuration;
    updated_obj.template_id = selectedThemes?.id;
    updated_obj.brands = authParams?.brandGroup
      ? authParams?.brandGroup
      : authParams?.compBrands
      ? authParams?.compBrands
      : authParams?.brandId
      ? authParams?.brandId
      : obj?.brands?.columns
      ? obj?.brands?.columns
      : obj?.brands
      ? obj?.brands
      : brandlogicalgroup?.length > 0
      ? [brandlogicalgroup[0]]
      : [brands[0]];

    // here profiles is all selected profiles
    let selectedProfiles = [];
    if (
      Array.isArray(obj?.profiles) &&
      obj?.profiles?.length > 0 &&
      Array.isArray(obj?.quick_filter_value?.columns) &&
      obj?.quick_filter_value?.columns?.length > 0
    ) {
      const commonProfiles = obj?.profiles?.filter((profile) =>
        obj?.quick_filter_value?.columns?.some((selectedProfile) => {
          return (
            String(profile?.id)?.toLowerCase() ===
              String(selectedProfile?.name)?.toLowerCase() ||
            String(profile?.id)?.toLowerCase() ===
              String(selectedProfile?.id)?.toLowerCase()
          );
        })
      );
      if (commonProfiles?.length > 0) selectedProfiles = commonProfiles;
    }

    updated_obj.profiles = selectedProfiles?.length > 0 ? selectedProfiles : [];
    updated_obj.ai_generated_insight = authParams?.ai;
    updated_obj.filters = authParams?.filters
      ? finalFilters
        ? finalFilters
        : authParams?.filters
      : [];
    dispatch(setPptDownload(updated_obj, authParams));
    dispatch(setImageList(null));
    global.image_list = null;

    dispatch(setPPTGenerateStatus(true));

    handleCancel(true);

    setcreatePPTFlg(false);
  };

  const callDashboardData = () => {
    global.callPPT = false;
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let graphObject = {
      start_date: authParams?.ppt_type
        ? authParams?.start_date
        : selectedDate
        ? selectedDate?.from
        : defaultDuration?.from,
      end_date: authParams?.ppt_type
        ? authParams?.end_date
        : selectedDate
        ? selectedDate?.to
        : defaultDuration?.to,
      password: null,
      filters: authParams?.ppt_type
        ? authParams?.filters
        : panes[index]?.filters,
    };
    let comp_brands =
      panes[index]?.template_type === "competition"
        ? getDefaultCompBrand(competitorBrands)
        : null;
    let quick_filter = panes[index]?.quick_filter_value
      ? panes[index]?.quick_filter_value
      : null;

    // new logic for formatting subset_filter in inner of columns
    let updatedColumnsMap = null;
    if (panes[index]?.quick_filter_value?.attribute === "Ads_Campaign") {
      // Example call to the function
      updatedColumnsMap = processQuickFilterForADCampaign(panes, index);
    }
    let quickFilterWithSubsetFilter = null;
    if (updatedColumnsMap && Array.from(updatedColumnsMap?.values())?.length) {
      quickFilterWithSubsetFilter = panes?.[index]?.quick_filter_value
        ? { ...panes?.[index]?.quick_filter_value }
        : null;
      if (
        quickFilterWithSubsetFilter?.columns &&
        Array.isArray(quickFilterWithSubsetFilter?.columns)
      )
        quickFilterWithSubsetFilter.columns = Array.from(
          updatedColumnsMap?.values()
        );
    }
    let option = {
      template_id: panes[index]?.template_id,
      template_name: panes[index]?.template_name,
      auth_params: authParams,
      brand_list: authParams?.brandGroup
        ? authParams?.brandGroup
        : authParams?.compBrands
        ? authParams?.compBrands
        : authParams?.brandId
        ? authParams?.brandId
        : panes[index]?.brands
        ? panes[index]?.brands
        : comp_brands,
      global_brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      start_date: graphObject?.start_date,
      end_date: graphObject?.end_date,
      password: graphObject?.password,
      filters: graphObject?.filters,
      quick_filter: quickFilterWithSubsetFilter
        ? quickFilterWithSubsetFilter
        : quick_filter
        ? quick_filter
        : undefined,
      ppt: true,
      panes: panes,
      pane_index: index,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      singleBrands: brands,
      profile_filters: authParams?.profile_filters
        ? authParams?.profile_filters
        : null,
    };
    let paneObj = {
      panes: panes,
      index: index,
      selectBrands: authParams?.brandGroup
        ? authParams?.brandGroup
        : authParams?.compBrands
        ? authParams?.compBrands
        : authParams?.brandId
        ? authParams?.brandId
        : panes[index]?.brands
        ? panes[index]?.brands
        : comp_brands,
    };

    dispatch(setPaneBrands(paneObj, "global_dashboard"));
    dispatch(setPdfPreviewMode(option));
  };
  function removeParam(parameter, url) {
    var urlparts = url.split("?");

    if (urlparts.length >= 2) {
      var urlBase = urlparts.shift();
      var queryString = urlparts.join("?");

      var prefix = encodeURIComponent(parameter) + "=";
      var pars = queryString.split(/[&;]/g);
      for (var i = pars.length; i-- > 0; )
        if (pars[i].lastIndexOf(prefix, 0) !== -1) pars.splice(i, 1);
      url = urlBase + "?" + pars.join("&");
    }
    return url;
  }

  const downloadPpt = () => {
    global.image_list = null;
    dispatch(setPptLoaderOffset(0));
    setSeeMore(false);

    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let graphObject = {
      start_date: selectedDate ? selectedDate?.from : defaultDuration?.from,
      end_date: selectedDate ? selectedDate?.to : defaultDuration?.to,
      brands: panes?.[index]?.brands?.columns
        ? panes?.[index]?.brands?.columns
        : panes?.[index]?.brands
        ? panes?.[index]?.brands
        : brandlogicalgroup?.length > 0
        ? [brandlogicalgroup[0]]
        : [brands[0]],
    };
    let brand_id = [],
      brand_group = [],
      comp_brand = [];
    if (graphObject?.brands?.[0]?.brand_group_name) {
      graphObject?.brands?.map(
        (el) => (brand_group = [...brand_group, el.brand_group_name])
      );
    } else if (graphObject?.brands?.[0]?.competitor) {
      brand_id = [graphObject?.brands?.[0]?.name];
      graphObject?.brands?.[0]?.competitorList?.map(
        (el) => (comp_brand = [...comp_brand, el.brand_id])
      );
    } else if (graphObject?.brands?.[0]?.brand_friendly_name) {
      graphObject?.brands?.map(
        (el) =>
          (brand_id = [...brand_id, el?.brand_id ? el?.brand_id : el.name])
      );
    }

    let alteredURL = removeParam("ptoken", window.location.href);
    alteredURL = removeParam("userid", alteredURL);
    let url = new URL(alteredURL);
    url.searchParams.append("ppt", 1);
    url.searchParams.append("ai", aiGenerated);
    url.searchParams.append("theme_id", selectedThemes?.id);
    url.searchParams.append("ppt_type", isImgselect);
    url.searchParams.append("startDate", graphObject?.start_date);
    url.searchParams.append("endDate", graphObject?.end_date);
    url.searchParams.append(
      "brandGroup",
      brand_group ? brand_group?.join(",") : null
    );
    url.searchParams.append("brandId", brand_id ? brand_id?.join(",") : null);
    url.searchParams.append(
      "compBrands",
      comp_brand ? comp_brand?.join(",") : null
    );
    if (panes[index]?.filters) {
      url.searchParams.append("filters", JSON.stringify(panes[index]?.filters));
    }
    let defaultProfileFilters = getByDefaultProfileFilters(profileFilterList);

    if (defaultProfileFilters) {
      url.searchParams.append(
        "profile_filters",
        JSON.stringify(defaultProfileFilters)
      );
    }
    if (panes[index]?.quick_filter && panes[index]?.quick_filter_value) {
      url.searchParams.append("quickFilterName", panes[index]?.quick_filter);
      url.searchParams.append(
        "quickFilterValue",
        getQuickFiltersIds(panes[index]?.quick_filter_value?.columns)
      );
      if (
        panes[index]?.quick_filter === "Ads_Campaign" &&
        panes[index]?.adsset_value
      ) {
        url.searchParams.append(
          "adssetValue",
          getQuickFiltersIds(panes[index]?.adsset_value?.columns)
        );
      }
      if (
        panes[index]?.quick_filter === "Ads_Campaign" &&
        panes[index]?.ads_value
      ) {
        url.searchParams.append(
          "adsValue",
          getQuickFiltersIds(panes[index]?.ads_value?.columns)
        );
      }
    }
    if (authParams?.template_id) {
      url.searchParams.append("template_id", authParams?.template_id);
    } else if (panes[index]?.template_id) {
      url.searchParams.append("template_id", panes[index]?.template_id);
    }

    window.open(url, "_blank");

    dispatch(setPPTModalOpen(false));
  };

  const getQuickFiltersIds = (data) => {
    let ids = data?.map((obj) => {
      return obj?.name;
    });
    return ids?.join("&");
  };

  useEffect(() => {
    if (authParams?.ppt == 1 && call_ppt && !indicatorToChachePdfData) {
      dispatch(setdownload(true));
      setIndicatorToChachePdfData(true);
      callDashboardData();
    }
  }, [authParams]);

  const screenshot = async (
    e,
    i,
    isImgselect,
    chartTypeData,
    chartDataLength
  ) => {
    if (i === chartDataLength - 1) {
      setcreatePPTFlg(true);
    }
    if (
      supportedChart?.includes(chartTypeData[i]?.graph_type) &&
      isImgselect === "native" &&
      !chartTypeData[i]?.isDurationComparisonExists &&
      !chartTypeData[i]?.downloadAsImage &&
      ((typeof chartTypeData[i]?.graphData !== "string" &&
        ((chartTypeData[i]?.graphData?.data[
          chartTypeData[i]?.graph_type === "horizontal-bar"
            ? "bar"
            : chartTypeData[i]?.graph_type
        ] &&
          ((chartTypeData[i]?.graphData?.data?.kpi?.length <= 0 &&
            chartTypeData[i]?.graphData?.data[
              chartTypeData[i]?.graph_type === "horizontal-bar"
                ? "bar"
                : chartTypeData[i]?.graph_type
            ][0]?.data) ||
            (chartTypeData[i]?.graphData?.data?.kpi?.length <= 0 &&
              chartTypeData[i]?.graphData?.data[
                chartTypeData[i]?.graph_type === "horizontal-bar"
                  ? "bar"
                  : chartTypeData[i]?.graph_type
              ][0]?.dataSource))) ||
          (chartTypeData[i]?.graphData?.data?.kpi &&
            chartTypeData[i]?.graphData?.data?.kpi?.length > 0 &&
            chartTypeData[i]?.graph_type === "kpi") ||
          Array.isArray(chartTypeData[i]?.graphData?.data))) ||
        typeof chartTypeData[i]?.graphData === "string")
    ) {
      let arr = global.image_list ? [...global.image_list] : [...image_list];
      let final_data;
      let obj = { ...chartTypeData[i] };
      obj.url =
        typeof chartTypeData[i]?.graphData === "string"
          ? "No data found"
          : chartTypeData[i]?.graphData;
      final_data = obj;
      arr.push(final_data ? final_data : chartTypeData[i]);
      global.image_list = arr;
      //await dispatch(setImageList(chartTypeData[i], image_list, true));
    } else {
      // Wait for the next animation frame to help ensure rendering is complete.
      await new Promise((resolve) => requestAnimationFrame(resolve));

      let htmlScreens = await document.getElementById(e);

      if (!htmlScreens) {
        console.error("Chart element not found!", htmlScreens);
        dispatch(setPptImageUrl(null, chartTypeData[i], image_list));
        return;
      }

      await domtoimage
        .toPng(htmlScreens, {
          cacheBust: true,
          cacheDisable: true,
        })
        .then((dataUrl) => {
          dispatch(setPptImageUrl(dataUrl, chartTypeData[i], image_list));
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
          dispatch(setPptImageUrl(null, chartTypeData[i], image_list));
        });
    }
  };

  const onChange = (type) => {
    setIsImgselect(type);
  };
  const handleNo = (value) => {
    setNotSupportedChart(true);
    setModalDataChange(false);
    setThemeList(false);
    setSeenoDataWidgets(false);
  };

  const handleThemePpt = () => {
    setNotSupportedChart(true);
    setModalDataChange(false);
    setThemeList(false);
  };
  const templateScroll = (e) => {
    if (seeMore) {
      let objDiv = document.getElementById("selectTheme");
      objDiv.scrollTop = 0;
    }
    const timer = setTimeout(() => {
      if (seeMore) {
        setSeeMore(e);
      } else {
        setSeeMore(e);
      }
    }, 300);
    return () => {
      clearTimeout(timer);
    };
  };
  const AIGenerated = (e) => {
    setAiGenerated(e);
    dispatch(setPptTemplateData(authParams, e));
  };
  return (
    <>
      <Modal
        title={
          modalDataChange && !notSupportedChart && !themeList && !download ? (
            <>
              <div className="text_heading text-transform__none fontSize-16 font-weight500">
                How you want to download the charts in the PPT?
              </div>
              <div className="text_regular text-transform__none font-weight400 line-height-normal">
                Choose your preferred method to download PPT.
              </div>
            </>
          ) : download ? null : !themeList ? (
            <div className="text_heading text-transform__none fontSize-16 font-weight500">
              Select Template Theme
            </div>
          ) : null
        }
        closable={download ? false : true}
        maskClosable={false}
        visible={isPPTModalOpen}
        onCancel={() => handleCancel()}
        width={
          modalDataChange && !notSupportedChart ? (themeList ? 500 : 680) : 760
        }
        className={`${download ? "chart_list-modal-p-0" : ""} ${
          authParams?.theme_type === "1" ? "darkTheme" : ""
        } chart_list-modal`}
        footer={
          download ? null : modalDataChange && !themeList ? (
            <>
              <Button
                type="button"
                onClick={() => handleCancel()}
                className="mr-2 btn_Clear"
              >
                Cancel
              </Button>
              {finalUnSupportedChart && isImgselect !== "native" && (
                <Button
                  type="primary"
                  onClick={() => {
                    setNotSupportedChart(true);
                    setModalDataChange(false);
                  }}
                  className="ant-btn-primary_blue"
                >
                  Next
                </Button>
              )}
              {isImgselect === "native" && (
                <Button
                  type="primary"
                  onClick={() => {
                    noDataWidgets?.length > 0
                      ? setThemeList(true)
                      : handleThemePpt();
                  }}
                  className="ant-btn-primary_blue"
                >
                  Next
                </Button>
              )}
            </>
          ) : notSupportedChart ? (
            <div className="d-flex justify-content-between">
              {ppt_template_data?.result?.template_details.length > 3 && (
                <Button
                  type="button"
                  onClick={() => {
                    setNotSupportedChart(true);
                    setThemeList(false);
                    templateScroll(!seeMore);
                  }}
                  className="mr-2 btn_Clear"
                >
                  Show {seeMore ? "Less" : "More"}
                </Button>
              )}
              <div>
                {(isImgselect === "image" || isImgselect === "native") && (
                  <Button
                    type="primary"
                    onClick={() => {
                      setModalDataChange(true);
                      setNotSupportedChart(false);
                      setThemeList(false);
                      setSeeMore(false);
                      templateScroll(false);
                    }}
                    className="mr-2 btn_Clear"
                  >
                    Back
                  </Button>
                )}
                <Button
                  type="primary"
                  onClick={(e) => downloadPpt(e)}
                  className="ant-btn-primary_blue"
                >
                  Download PPT
                </Button>
              </div>
            </div>
          ) : (
            themeList && (
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setModalDataChange(true);
                    setNotSupportedChart(false);
                    setThemeList(false);
                    setSeenoDataWidgets(false);
                    templateScroll(false);
                  }}
                  className="btn_Clear"
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  onClick={() => handleNo()}
                  className="ant-btn-primary_blue"
                >
                  Next
                </Button>
              </>
            )
          )
        }
      >
        {download ? (
          notification.open({
            className: "notification_body",
            key: 1,
            placement: "bottomLeft",
            icon: download && (
              <img
                src={rotate_right}
                alt="loading"
                style={{ width: "2rem", height: "2rem" }}
              />
            ),
            duration: 300000,
            message: (
              <div className="d-flex flex-column " style={{ width: "35rem" }}>
                <div className="d-flex justify-content-between">
                  <div className=" text_regular-lightgray">
                    <span className=" ">Generating your PPT report...</span>
                  </div>

                  <span className="  text-lightblue ">{ppt_offset + "%"}</span>
                </div>

                <Progress width={1400} percent={ppt_offset} showInfo={false} />
              </div>
            ),
          })
        ) : (
          <>
            <div
              className={themeList && noDataWidgets?.length > 0 ? "" : "d-none"}
            >
              <div className="text_heading d-flex align-items-start fontSize-16 mb-2 font-weight500">
                <img
                  src={Alert}
                  alt="alert"
                  className="mr-15"
                  style={{ maxWidth: "4rem" }}
                />
                <div>
                  <span className="line-height-normal text-transform__none d-block pr-4">
                    {noDataWidgets?.length === 1
                      ? "One of the widget in this dashboard does not have any data. The PPT export will skip this widget."
                      : `${noDataWidgets?.length} of the ${chartsList?.length} widgets in this dashboard do not have any data. The PPT export will skip these widgets.`}
                  </span>
                  <div
                    onClick={() => setSeenoDataWidgets(!seenoDataWidgets)}
                    className={`cursor-pointer blue-text font-weight400 text_regular mt-15`}
                  >
                    See {seenoDataWidgets ? "Less" : "More"} Details
                  </div>
                </div>
              </div>

              <div
                className={`${
                  seenoDataWidgets ? "d-flex flex-wrap" : "d-none"
                } align-items-start flex-wrap`}
              >
                <div className="text_heading font-weight500 mb-15 w-100">
                  Following widget(s) will be skipped in the PPT report.
                </div>
                {noDataWidgets?.length > 0 ? (
                  noDataWidgets.map((el, i) => {
                    return (
                      <div
                        style={{ width: "12.4rem" }}
                        className="border border-color border-radius-4 text-center mb-15 mr-15 pt-2 pb-2"
                      >
                        {chartTypewithicon[
                          shedString(el?.graph_type, "-")?.toLowerCase()
                        ] ? (
                          <img
                            src={
                              chartTypewithicon[
                                shedString(el?.graph_type, "-")?.toLowerCase()
                              ]
                            }
                            alt={el?.graph_type}
                            style={{
                              maxWidth: "100%",
                              height: "6rem",
                            }}
                            className="mb-2"
                          />
                        ) : (
                          <img
                            src={somethingWentWrong}
                            alt={el?.graph_type}
                            style={{
                              maxHeight: "100%",
                              width: "6rem",
                            }}
                            className="mb-2"
                          />
                        )}
                        <div className="text_regular text-ellipsis pl-2 pr-2 line-height-normal pt-2 border-top border-color">
                          <Tooltip title={el?.widget_name}>
                            {el?.widget_name}
                          </Tooltip>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="w-100 text-center mb-15">
                    <img
                      src={somethingWentWrong}
                      alt={somethingWentWrong}
                      style={{
                        height: "10rem",
                        width: "10rem",
                      }}
                    />
                    <div className="text_regular-gray">No Data Found</div>
                  </div>
                )}
              </div>
            </div>
            <div
              className={
                modalDataChange && !notSupportedChart && !themeList
                  ? ""
                  : "d-none"
              }
            >
              <div className="mb-15 d-flex justify-content-center">
                <div
                  onClick={() => {
                    onChange("image");
                  }}
                  onDoubleClick={() => {
                    setNotSupportedChart(true);
                    setModalDataChange(false);
                  }}
                  className={`mr-3 box-shadow border_width2 cursor-pointer border ${
                    isImgselect === "image" ? "border-blue" : "border-color"
                  } border-radius-8 p-15 text-center`}
                  style={{ maxWidth: "20rem" }}
                >
                  <img
                    src={
                      isImgselect === "image"
                        ? pptDownloadImages
                        : pptDownloadImagesGray
                    }
                    className="mb-15"
                    style={{ maxWidth: "10rem" }}
                    alt="ppt Download Images"
                  />
                  <div className="text_heading font-weight600">
                    Download as Images
                  </div>
                  <div className="text_regular">
                    The charts will be downloaded as images.
                  </div>
                </div>
                <div
                  onClick={() => onChange("native")}
                  onDoubleClick={() => {
                    noDataWidgets?.length > 0
                      ? setThemeList(true)
                      : handleThemePpt();
                  }}
                  className={`cursor-pointer border_width2 box-shadow mr-1 border ${
                    isImgselect === "native" ? "border-blue" : "border-color"
                  } border-radius-8 p-15 text-center`}
                  style={{ maxWidth: "20rem" }}
                >
                  <img
                    src={
                      isImgselect === "native"
                        ? pptDownloadNative
                        : pptDownloadNativeGray
                    }
                    className="mb-15"
                    style={{ maxWidth: "10rem" }}
                    alt="ppt Download Native"
                  />
                  <div className="text_heading font-weight600">
                    Download as Native
                  </div>
                  <div className="text_regular">
                    The applicable charts will be downloaded as editable charts
                    in the PPT.
                  </div>{" "}
                </div>
              </div>
              <div className="font-weight500 text_regular mb-15">
                {/* <Checkbox onChange={(e) => AIGenerated(e?.target?.checked)}>
                  Download with AI generated insights
                </Checkbox> */}
                {/* Download with AI generated insights */}
                {/* AI generated insights in the PPT export. */}
                {/* <span className="error ml-1">Coming Soon</span> */}
              </div>
              <div
                className={`text_regular line-height-normal mb-15 border-radius-4 p-2 ${
                  isImgselect === "native" ? "" : "d-none"
                }`}
                style={{
                  border: "0.1rem #DEAA0C33 solid",
                  backgroundColor: "#deaa0c1a",
                }}
              >
                <span style={{ color: "#DEAA0C" }}>Note:</span> Some of the
                advanced visualisations are not supported in the PPT. These will
                be downloaded as images instead.
              </div>
            </div>
            <div className="text-right mb-15 pointer-events">
              {/* <Upload
                    //{...props}
                    >
                      <Button>Click to Upload</Button>{" "}
                      <span className="error">Coming Soon</span>
                    </Upload> */}
            </div>
            <div className={notSupportedChart ? "" : "d-none"}>
              <div
                className="mb-15 custom_scroll1"
                id="selectTheme"
                style={{
                  maxHeight: seeMore ? "calc(100vh - 28.2rem)" : "18rem",
                  overflow: seeMore ? "auto" : "hidden",
                }}
              >
                <div className="row mr-0">
                  {ppt_template_data?.result?.template_details?.map((el, i) => {
                    return (
                      <div
                        className={`col-12 col-md-4 pr-0`}
                        onClick={() =>
                          setSelectedThemes({ id: i, value: true })
                        }
                        onDoubleClick={() => downloadPpt()}
                      >
                        <div
                          className={`border mb-15 cursor-pointer overflow-hidden border_width2 ${
                            selectedThemes?.id === i
                              ? "border-blue"
                              : "border-color"
                          } box-shadow border-radius-4`}
                        >
                          <div
                            className="w-100 theme_bg border-bottom bg__gray"
                            style={{
                              height: "12.9rem",
                              backgroundImage: `url(${el?.template_images[0]})`,
                            }}
                          />
                          <div className="text-center pt-2 pb-2">
                            <Button
                              type="primary"
                              className="btn_Clear"
                              onClick={() =>
                                setPreviewModal({
                                  preview: true,
                                  templateData: el,
                                })
                              }
                            >
                              Preview
                            </Button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </>
        )}
      </Modal>
      {previewModal?.preview && !download && (
        <TemplatePreview
          downloadPpt={downloadPpt}
          download={download}
          setPreviewModal={setPreviewModal}
          previewModal={previewModal}
          setdownload={setdownload}
        />
      )}
    </>
  );
};

export default React.memo(ModalPpt, isEqual);
